/**
 * Authorization Roles
 */
export var authRoles = {
    admin: ['admin'],
    isAdmin: ['admin'],
    isLoggedIn: ['admin', 'member'],
    isLoggedOut: ['guest'],
    staff: ['admin', 'staff'],
    onlyGuest: ['guest'],
    member: ['admin', 'member'],
};



//////////////////
// WEBPACK FOOTER
// ./src/auth/auth.ts
// module id = 555
// module chunks = 81